import { Directive, ElementRef, AfterViewInit, Input } from '@angular/core';

@Directive({
  selector: '[onafriq-radio]', // If you're using Angular 20; otherwise add the directive to the module declaration
})
export class FixRadioNameDirective implements AfterViewInit {
  @Input() customName?: string;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    // Finds the inner native input and changes its name
    const input = this.el.nativeElement.querySelector('input[type="radio"]');
    if (input) {
      input.name = this.customName || `patched-radio-${Math.random()}`;
    }
  }
}